import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class OfferService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('offer/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('offer/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('offer/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('offer/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('offer/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('offer/delete', val_id);
  }
}
